import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "q-row autocomplete-popup__container" }
const _hoisted_2 = {
  key: 1,
  class: "autocomplete-popup__no-results"
}

import ProductsContainer from '@/components/AutocompletePopup/Products/ProductsContainer.vue';
import SuggestionsContainer from '@/components/AutocompletePopup/ShowResults/Suggestions/SuggestionsContainer.vue';
import MoreResultsButton from '@/components/AutocompletePopup/ShowResults/Results/MoreResultsButton.vue';
import { computed, inject, ref, unref } from 'vue';
import { CustomSmartSearchLabels, SmartSearchConfigInterface, SmartSearchTranslationsInterface } from '@/core/types';
import {storeToRefs} from "pinia";
import {useSearchQueryStore} from "@/store/SearchQueryStore";
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'AutocompleteContainer',
  setup(__props) {

const SmartSearchConfig = ref(inject<SmartSearchConfigInterface>('SmartSearchConfig')!);
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject('SmartSearchTranslations') as any;
const suggestionsEnabled = SmartSearchConfig.value.autocomplete.suggestions.enabled;
const bestsellerEnabled = SmartSearchConfig.value.autocomplete.bestseller.enabled;
const customLabels = (typeof window !== 'undefined'
  ? (window as any)?._QONizer?.customSmartSearchConfig?.labels
  : undefined) as CustomSmartSearchLabels | undefined;

const searchQueryStore = useSearchQueryStore();
const { searchQuery } = storeToRefs(searchQueryStore);
const popupStore = usePopupStore();
const {
  getAutocompleteResults,
  hasNoResults,
  getAutocompleteResultsWithoutFirst,
  getBestseller,
  canShowPromotedSection
} = storeToRefs(popupStore);

const customRedirects = window?._QONizer?.customSmartSearchConfig?.customRedirects || [];

const matchedRedirect = computed(() => {
  const queryLower = searchQuery.value.toLowerCase().trim();
  return customRedirects.find(redirect => redirect.phrases.some(phrase => phrase.toLowerCase() === queryLower));
});

const autocompleteTranslations = computed(() => unref(SmartSearchTranslations)?.autocomplete ?? {});
const fallbackAutocomplete = {
  resultsHeader: 'Znalezione produkty',
  noResults: 'Nie znaleźliśmy produktów dla zapytania',
  bestsellerHeader: 'Wyróżniony produkt'
};

const normalizeLabel = (label: unknown): string | undefined => {
  if (typeof label !== 'string') {
    return undefined;
  }

  const trimmed = label.trim();
  return trimmed || undefined;
};

const redirectResultsHeader = computed(() => {
  const customLabel = normalizeLabel(customLabels?.autocomplete?.redirectResultsHeader);
  if (customLabel) {
    return customLabel;
  }

  const translationLabel = normalizeLabel(autocompleteTranslations.value?.redirectResultsHeader);
  if (translationLabel) {
    return translationLabel;
  }

  return 'Znaleźliśmy stronę odpowiadającą Twojemu zapytaniu';
});

const productsHeader = computed(() =>
  matchedRedirect.value
    ? redirectResultsHeader.value
    : normalizeLabel(autocompleteTranslations.value?.resultsHeader) || fallbackAutocomplete.resultsHeader
);

const noResultsText = computed(() => normalizeLabel(autocompleteTranslations.value?.noResults) || fallbackAutocomplete.noResults);
const bestsellerHeader = computed(() => normalizeLabel(autocompleteTranslations.value?.bestsellerHeader) || fallbackAutocomplete.bestsellerHeader);

// Funkcja do formatowania tekstu (pierwsza litera każdego wyrazu wielka)
const capitalizeWords = (str: string) => {
  return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
};

const results = computed(() => {
  if (matchedRedirect.value) {
    const customItem = {
      type: 'custom',
      url: matchedRedirect.value.url,
      label: capitalizeWords(searchQuery.value) // Formatujemy label
    };
    return [customItem];
  }
  return bestsellerEnabled && canShowPromotedSection.value ? getAutocompleteResultsWithoutFirst.value : getAutocompleteResults.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(suggestionsEnabled) && !matchedRedirect.value)
      ? (_openBlock(), _createBlock(SuggestionsContainer, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(hasNoResults) && !matchedRedirect.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _createTextVNode(_toDisplayString(noResultsText.value) + ": ", 1),
          _createElementVNode("b", null, _toDisplayString(_unref(searchQuery)), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: "autocompleteResults",
      class: _normalizeClass(["autocomplete-popup__results-container", {
       'q-col-lg-12 q-pt-1': matchedRedirect.value || !_unref(suggestionsEnabled),
       'q-col-12 q-col-lg-9 q-pt-1': !matchedRedirect.value && _unref(suggestionsEnabled)
     }])
    }, [
      _createVNode(ProductsContainer, {
        "products-header": productsHeader.value,
        "section-enabled": true,
        "promoted-product-enabled": _unref(bestsellerEnabled) && !matchedRedirect.value,
        "promoted-product": _unref(getBestseller),
        "promoted-product-header": bestsellerHeader.value,
        "products-list": results.value,
        "can-show-promoted-section": _unref(canShowPromotedSection) && !matchedRedirect.value
      }, null, 8, ["products-header", "promoted-product-enabled", "promoted-product", "promoted-product-header", "products-list", "can-show-promoted-section"]),
      (!matchedRedirect.value)
        ? (_openBlock(), _createBlock(MoreResultsButton, { key: 0 }))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})